export const deniedStates = [
  'insurance_denied',
  'boatbound_denied',
  'international',
  'blocked',
  'deactivated',
  'denied',
];
export const pendingStates = [
  'pending_review',
  'survey_received',
  'corrections_needed',
  'pending_insurance',
  'pending_survey',
];
